<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 246.415 246.415"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      v-if="type !== ''"
      :id="iconName"
      lang="en"
    >{{ type }} icon</title>
    <path id="Path_4283" :fill="iconColor" data-name="Path 4283" d="M1014.569,2002.285a123.207,123.207,0,1,0-123.208,123.207A123.2,123.2,0,0,0,1014.569,2002.285Zm-123.208,102.6A102.6,102.6,0,0,1,876.7,1900.859V1936.4a14.657,14.657,0,1,0,29.314,0v-35.544a102.6,102.6,0,0,1-14.658,204.027Z" transform="translate(-768.154 -1879.077)"/>
    <g v-if="type === 'A'" id="Group_3363" data-name="Group 3363" transform="translate(83.654 98.431)">
      <path  :fill="iconColor" id="Path_4284" data-name="Path 4284" d="M898.025,2037.573l-4.071-10.7H859.285l-4.072,10.934q-2.384,6.4-4.071,8.639t-5.526,2.241a8.105,8.105,0,0,1-5.76-2.385,7.307,7.307,0,0,1-2.5-5.412,12.105,12.105,0,0,1,.581-3.605q.582-1.863,1.919-5.177l21.813-55.375q.929-2.385,2.24-5.729a28.966,28.966,0,0,1,2.792-5.557,11.341,11.341,0,0,1,3.9-3.576,11.936,11.936,0,0,1,5.962-1.366,12.072,12.072,0,0,1,6.021,1.366,11.569,11.569,0,0,1,3.9,3.519,24.767,24.767,0,0,1,2.5,4.623q1.018,2.474,2.588,6.6l22.279,55.026q2.616,6.283,2.617,9.135a7.563,7.563,0,0,1-2.472,5.436,8.135,8.135,0,0,1-5.963,2.474,7.734,7.734,0,0,1-3.49-.729,7.16,7.16,0,0,1-2.442-1.978,18.311,18.311,0,0,1-2.123-3.836Q898.84,2039.551,898.025,2037.573Zm-34.2-23.674H889.3l-12.854-35.192Z" transform="translate(-837.356 -1960.503)"/>
    </g>
    <g v-else-if="type === 'B'">
      <path :fill="iconColor" d="M125.7,185.05H99.23c-3.82,0-6.55-0.86-8.18-2.57c-1.64-1.71-2.45-4.44-2.45-8.18v-65.11
        c0-3.82,0.84-6.57,2.51-8.24c1.67-1.67,4.38-2.51,8.12-2.51h28.07c4.14,0,7.72,0.26,10.75,0.77c3.03,0.51,5.75,1.5,8.15,2.95
        c2.05,1.22,3.86,2.77,5.44,4.64c1.58,1.87,2.78,3.94,3.6,6.2c0.83,2.27,1.24,4.66,1.24,7.18c0,8.67-4.33,15.01-13,19.03
        c11.38,3.63,17.08,10.68,17.08,21.15c0,4.84-1.24,9.21-3.72,13.09c-2.48,3.88-5.83,6.75-10.05,8.6c-2.64,1.1-5.67,1.88-9.1,2.33
        C134.27,184.82,130.27,185.05,125.7,185.05z M106.15,111.6V134h16.07c4.37,0,7.75-0.41,10.13-1.24c2.38-0.83,4.2-2.4,5.47-4.73
        c0.98-1.66,1.48-3.51,1.48-5.55c0-4.37-1.56-7.28-4.67-8.72c-3.11-1.44-7.86-2.16-14.24-2.16H106.15z M124.4,146.58h-18.26v25.29
        h18.85c11.86,0,17.79-4.27,17.79-12.82c0-4.37-1.54-7.54-4.61-9.51C135.1,147.57,130.51,146.58,124.4,146.58z"/>
    </g>
    <g v-else-if="type === 'C'" id="Group_3366" data-name="Group 3366" transform="translate(84.414 97.447)">
      <g id="Group_3365" data-name="Group 3365">
        <path :fill="iconColor" id="Path_4286" data-name="Path 4286" d="M1248.368,2020.553a23.141,23.141,0,0,1-2.042,8.969,32.32,32.32,0,0,1-6.424,9.472,32.779,32.779,0,0,1-11.191,7.552,40.256,40.256,0,0,1-15.867,2.9,55.334,55.334,0,0,1-12.491-1.3,35.113,35.113,0,0,1-10.214-4.054,34.442,34.442,0,0,1-8.436-7.254,43.03,43.03,0,0,1-5.863-9.146,47.562,47.562,0,0,1-3.642-10.807,58.9,58.9,0,0,1-1.213-12.2,54.085,54.085,0,0,1,3.05-18.768,40.024,40.024,0,0,1,8.732-14.179,38.09,38.09,0,0,1,13.322-8.97,43.153,43.153,0,0,1,16.282-3.078,40.694,40.694,0,0,1,18.767,4.2,34,34,0,0,1,12.612,10.393q4.382,6.186,4.381,11.691A7.622,7.622,0,0,1,1246,1991.3a6.755,6.755,0,0,1-5.151,2.31,7.115,7.115,0,0,1-5.062-1.6,22.067,22.067,0,0,1-3.759-5.508,26.5,26.5,0,0,0-8.082-9.647,19.726,19.726,0,0,0-11.457-3.2,20.759,20.759,0,0,0-17.258,8.229q-6.426,8.229-6.424,23.388,0,10.121,2.841,16.843a21.268,21.268,0,0,0,8.054,10.036,22.222,22.222,0,0,0,12.2,3.316,21.4,21.4,0,0,0,12.817-3.761,22.705,22.705,0,0,0,7.906-11.041,18.661,18.661,0,0,1,2.782-5.595q1.656-2.163,5.327-2.162a7.45,7.45,0,0,1,5.389,2.191A7.3,7.3,0,0,1,1248.368,2020.553Z" transform="translate(-1170.985 -1959.689)"/>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
